import React, {FC, useEffect, useState} from 'react';
import {Modal, Button, Typography, Spin} from 'antd';
import {useNavigate} from 'react-router-dom';
import authService from '../../../services/authService';
import * as authActions from '../../../store/modules/auth/actions';
import {useDispatch} from 'react-redux';

const {Title, Paragraph, Text} = Typography;

const OnboardingSuccessPage: FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [canWithdraw, setCanWithdraw] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const checkProfile = async () => {
            try {
                const result = await authService.getProfile();
                dispatch(authActions.loginSuccess(true, result.data));
                setCanWithdraw(result.data.canWithdraw);
            } catch (error: any) {
                console.error(error);
                setError('Failed to verify your account status.');
            } finally {
                setLoading(false);
            }
        };
        checkProfile();
    }, []);

    if (loading) return <Spin style={{margin: 20}}/>;

    if (error) {
        return (
            <Modal visible title="Something went wrong" footer={null} closable={false} maskClosable={false}>
                <Text type="danger">{error}</Text>
                <div style={{textAlign: 'right', marginTop: 16}}>
                    <Button onClick={() => navigate('/profile')}>Go to Profile</Button>
                </div>
            </Modal>
        );
    }

    if (!canWithdraw) {
        return (
            <Modal visible title="Onboarding Incomplete" footer={null} closable={false} maskClosable={false}>
                <Title level={4}>Almost there!</Title>
                <Paragraph>
                    Your payout setup still needs attention. Please go to your profile, click &#34;Get verified&#34;,
                    and complete any identity verification or bank account steps required before withdrawals.
                </Paragraph>
                <div style={{textAlign: 'right'}}>
                    <Button type="primary" onClick={() => navigate('/profile')}>
                        Go to Profile
                    </Button>
                </div>
            </Modal>
        );
    }

    return (
        <Modal visible title="Payout Setup Complete" footer={null} closable={false} maskClosable={false}>
            <Title level={4}>You&#39;re all set!</Title>
            <Paragraph>
                Your payout setup is complete. You can now withdraw funds from your wallet.
            </Paragraph>
            <div style={{textAlign: 'right'}}>
                <Button type="primary" onClick={() => navigate('/wallet')}>Go to Wallet</Button>
            </div>
        </Modal>
    );
};

export default OnboardingSuccessPage;
